module.exports = __webpack_public_path__ + "img/i_letter.fb8d306d.svg";